import { createExcelAndDownload } from '../../../../utils/reportExcelExport';

export function Report(vouchers) {
    const customHeadings = [
        { key: "invoice_no", label: "Voucher No" },
        { key: "voucher_date", label: "Voucher Date", isDate: true },
        { key: "invoice.due_date", label: "Due Date", isDate: true },
        { key: "invoice.is_extended", label: "DueDateExtended?" },
        { key: "extended_at", label: "Extended Date", isDate: true },
        { key: "extended_by", label: "Extended By" },
        { key: "invoice.total_amount", label: "Total Amount" },
        { key: "invoice.discount", label: "Discount" },
        { key: "voucher_type", label: "Voucher Type" },
        { key: "paid_amount", label: "Paid Amount" },
        { key: "invoice.payment_status", label: "Status" },
    ];
    createExcelAndDownload("All Voucher Report", vouchers, customHeadings, {
        transformCell: (key, value) => {
            if (key === "invoice.is_extended") {
                return value ? "Yes" : "No";
            }
            return value;
        },
    });
}
